import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import { AmountCard } from "./RefundTabs.styled";
import { FC, ReactElement, useEffect, useState } from "react";
import General from '../../stores/GeneralStore'
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import ArrowDown from '../../assets/arrowDown.svg';
interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  destinationAccounts: Obj[],
  selectedAccounts: Obj[],
  makeTransfer: (destAccountId: string) => void,
  loadDestinationAccountsList: () => Promise<void>,
  transferLoader: Boolean
}

const TransferTab: FC<Props> = ({ selectedAccounts, makeTransfer, Previous, destinationAccounts, transferLoader, loadDestinationAccountsList }: Props): ReactElement => {

  const [selectedAccount, setSelectedAccount] = useState<number>(-1)
  const handleAccountSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const index = parseInt(event.target.value)
    setSelectedAccount(index)
  }

  const handleMakeTransfer = () => {

    if (selectedAccount != null) {
      makeTransfer(destinationAccounts?.[selectedAccount]?.accountId)
    }
  }
  useEffect(() => {
    loadDestinationAccountsList()
  }, [])

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <TabContainer style={{
      width: "100%", paddingTop: "30px",
      flexDirection: 'column',
      display: General?.isLargeScreen ? "" : 'flex'
    }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "space-between",

        }}
      >
        <span style={{
          paddingBottom: "20px",
          fontSize: `${General.accessibility.fontSize}rem`,
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss
        }}>
          {General?.codeLabels["cm_select_acc"]?.label !== undefined ? General?.codeLabels["cm_select_acc"]?.label : "Select the account to transfer selected amount"}
        </span>
        <AmountCard style={{ width: General?.isLargeScreen ? "" : "100%", background: contrast?.contrastColor ? contrast?.contrastColor : "" }}>
          <span style={{ fontSize: `${1.25 * General.accessibility.fontSize}rem`, fontWeight: "400", fontStyle: "normal", lineHeight: "32px", color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss }}> {General?.codeLabels["cm_pdc_amountinaed"]?.label !== undefined ? General?.codeLabels["cm_pdc_amountinaed"]?.label : "AED"}</span>
          <span style={{ fontSize: `${2.5 * General.accessibility.fontSize}rem`, fontWeight: "400", fontStyle: "normal", lineHeight: "32px", color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss, direction: 'ltr' }}>
            {
              new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Math.abs(selectedAccounts.reduce((partialSum, a) => {
                return partialSum + (a.accountBalance || 0);
              }, 0)))
            }

          </span>
        </AmountCard>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <Label style={{
          fontWeight: "700",
          fontSize: `${General.accessibility.fontSize}rem`,
          fontStyle: "normal",
          lineHeight: "16px",
          gap: "0.5rem",
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss
        }}
        >
          {General?.codeLabels["cm_select_destimationaccount"]?.label !== undefined ? General?.codeLabels["cm_select_destimationaccount"]?.label : "Select Destination Account"}
          <select style={{
            width: General?.isLargeScreen?"535px":"300px",
            background: contrast?.contrastColor ? contrast.contrastColor : "",
            paddingLeft: "5px"
            
          }} 
            value={selectedAccount}
            onChange={(e) => {
            handleAccountSelect(e)
          }}

          >
            <option value={-1} disabled hidden>
              {General?.codeLabels["cm_refund_select_option"]?.label !== undefined ? General?.codeLabels["cm_refund_select_option"]?.label : "Select an option"}
            </option>

            {destinationAccounts?.map((account, index) => (
              <option key={index} value={index}>
                {account.accountId}
              </option>
            ))}

          </select>
        </Label>
        <Label style={{
          justifyContent: "space-evenly", fontWeight: "700",
          fontSize: `${General.accessibility.fontSize}rem`,
          fontStyle: "normal",
          lineHeight: "18px",
          gap: "0.5rem",
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss
        }}
        >
          {General?.codeLabels["cm_pdc_premisedetails"]?.label !== undefined ? General?.codeLabels["cm_pdc_premisedetails"]?.label : "Premise Details"}
          <span style={{ fontWeight: "500", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
            {destinationAccounts?.length <= 1 ? destinationAccounts?.[0]?.premiseInfo : selectedAccount >= 0 ? destinationAccounts?.[selectedAccount].premiseInfo : 'No Premise Details'}
          </span>
        </Label>
      </div>
      <hr style={{
        width: "100%", gridColumn: "1 / span 2", background: "#101E8E",
        mixBlendMode: "normal", opacity: "0.2 "
      }} />
      <ButtonsContainer style={{ gridColumn: General?.isLargeScreen ? "1 / span 2" : "", flexDirection: General?.isLargeScreen ? "row" : "column", width: General?.isLargeScreen ? '' : "100%" }}>
        <ButtonSecondary
          style={{
            padding: "auto",
            fontFamily: "Segoe UI",
            fontWeight: "700",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "20px",
            height: "50px",
            width: General?.isLargeScreen ? "163px" : "100%",
            color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, 
            background: contrast?.contrastBackground ? contrast?.contrastBackground : "",
            borderColor: contrast?.contrastColor ? contrast?.contrastColor : ColorAss
          }}
          onClick={Previous}
        >
          {General?.codeLabels["cm_backbutton"]?.label !== undefined ? General?.codeLabels["cm_backbutton"]?.label : "BACK"}
        </ButtonSecondary>
        <ButtonSecondary
          style={{
            fontFamily: "Segoe UI",
            fontWeight: "700",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "20px",
            height: "50px",
            marginTop: General?.isLargeScreen ? '' : "1rem",
            width: General?.isLargeScreen ? "242px" : "100%",
            padding: "auto",
            color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            border:'none',
            opacity: selectedAccount == null ? '0.5' : '1'
          }}
          disabled={selectedAccount == null ? true : false}
          onClick={() => {
            handleMakeTransfer()
          }}
        >
          {General?.codeLabels["cm_transfer"]?.label !== undefined ? General?.codeLabels["cm_transfer"]?.label : "TRANSFER"}
        </ButtonSecondary>
      </ButtonsContainer>
    </TabContainer>
  );
};

export default observer(TransferTab);
